module.exports = __webpack_public_path__ + "img/Ktrebol.aa73cfd0.png";